"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Sidebar_1 = __importDefault(require("./Sidebar/Sidebar"));
var Content_1 = __importDefault(require("./Content/Content"));
var ResponsiveHelper_1 = __importDefault(require("../ResponsiveHelper/ResponsiveHelper"));
/**
 * The SidebarLayout handles appplication navigation by providing layout of a main menu beside view content.
 * @child ./Sidebar/Sidebar.tsx
 * @child ./Content/Content.tsx
 */
var SidebarLayout = /** @class */ (function (_super) {
    __extends(SidebarLayout, _super);
    function SidebarLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.breakpointsWidthCheck = function (points) {
            if (!points.s) {
                _this.setState({ compressed: true });
            }
            else {
                _this.setState({ compressed: false });
            }
        };
        _this.state = {
            compressed: false
        };
        return _this;
    }
    SidebarLayout.prototype.render = function () {
        var _a = this.props, collapsed = _a.collapsed, className = _a.className, noIcons = _a.noIcons, rest = __rest(_a, ["collapsed", "className", "noIcons"]);
        return (React.createElement("div", __assign({}, rest, { className: this.genClasses() }),
            this.props.children,
            React.createElement(ResponsiveHelper_1.default, { activeBreakPoints: this.breakpointsWidthCheck })));
    };
    SidebarLayout.prototype.genClasses = function () {
        var _a = this.props, collapsed = _a.collapsed, noIcons = _a.noIcons, className = _a.className;
        var compressed = this.state.compressed;
        var classes = 'sidebar-layout';
        if (noIcons) {
            classes += ' no-icons';
        }
        if (className) {
            classes += ' ' + className;
        }
        if (collapsed) {
            classes += ' collapse';
        }
        if (compressed) {
            classes += ' compressed';
        }
        return classes;
    };
    SidebarLayout.defaultProps = {
        collapsed: false,
        noIcons: false
    };
    SidebarLayout.Sidebar = Sidebar_1.default;
    SidebarLayout.Content = Content_1.default;
    return SidebarLayout;
}(react_1.Component));
exports.default = SidebarLayout;
